import {
  __objRest
} from "./chunk-WNQUEZJF.mjs";

// src/hooks/media/use-track-media/use-track-media.tsx
import {
  MediaListeners
} from "@youversion/analytics-youversion-private";
import { useEffect, useState } from "react";
var TrackMedia = {
  AudioBibleReference: {
    useListeners: (ref, { audioBibleVersionId, usfm }) => {
      const [handlers, setHandlers] = useState();
      useEffect(() => {
        if (ref && typeof ref !== "function" && ref.current) {
          const _a = MediaListeners.AudioBibleReference.setup(ref.current, {
            audioBibleVersionId,
            usfm
          }), { cleanup: cleanupListeners } = _a, allHandlers = __objRest(_a, ["cleanup"]);
          setHandlers(allHandlers);
          return () => {
            allHandlers.handleDocumentUnload();
            cleanupListeners();
          };
        }
      }, [audioBibleVersionId, ref, usfm]);
      return handlers;
    }
  },
  GuidedPrayerBackgroundAudio: {
    useListeners: (ref, { audioCategoryId, dayId, guideId }) => {
      const [handlers, setHandlers] = useState();
      useEffect(() => {
        if (ref && typeof ref !== "function" && ref.current) {
          const _a = MediaListeners.GuidedPrayerBackgroundAudio.setup(
            ref.current,
            {
              audioCategoryId,
              dayId,
              guideId
            }
          ), { cleanup: cleanupListeners } = _a, allHandlers = __objRest(_a, ["cleanup"]);
          setHandlers(allHandlers);
          return () => {
            allHandlers.handleDocumentUnload();
            cleanupListeners();
          };
        }
      }, [audioCategoryId, dayId, guideId, ref]);
      return handlers;
    }
  },
  PlanDevotionalAudio: {
    useListeners: (ref, { languageTag, readingPlanDay, readingPlanId, subscriptionId }) => {
      const [handlers, setHandlers] = useState();
      useEffect(() => {
        if (ref && typeof ref !== "function" && ref.current) {
          const _a = MediaListeners.PlanDevotionalAudio.setup(ref.current, {
            languageTag,
            readingPlanDay,
            readingPlanId,
            subscriptionId
          }), { cleanup: cleanupListeners } = _a, allHandlers = __objRest(_a, ["cleanup"]);
          setHandlers(allHandlers);
          return () => {
            allHandlers.handleDocumentUnload();
            cleanupListeners();
          };
        }
      }, [languageTag, readingPlanDay, readingPlanId, ref, subscriptionId]);
      return handlers;
    }
  },
  Video: {
    useListeners: (ref, { languageTag, videoId }) => {
      const [handlers, setHandlers] = useState();
      useEffect(() => {
        if (ref && typeof ref !== "function" && ref.current) {
          const _a = MediaListeners.Video.setup(ref.current, {
            languageTag,
            videoId
          }), { cleanup: cleanupListeners } = _a, allHandlers = __objRest(_a, ["cleanup"]);
          setHandlers(allHandlers);
          return () => {
            allHandlers.handleDocumentUnload();
            cleanupListeners();
          };
        }
      }, [languageTag, ref, videoId]);
      return handlers;
    }
  }
};

export {
  TrackMedia
};
